// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/network/network.proto" (package "mlmbox.client.network", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Network } from "./network.ts";
import type { TeamPartnerListRequest } from "./network.ts";
import type { TeamResponse } from "./network.ts";
import type { TeamRequest } from "./network.ts";
import type { Account_Info_List } from "../../types/account.ts";
import type { AccountsSearchRequest } from "./network.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { Account_Info } from "../../types/account.ts";
import type { Account_Id } from "../../types/account.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.network.Network
 */
export interface INetworkClient {
    /**
     * @generated from protobuf rpc: MemberGet(mlmbox.types.Account.Id) returns (mlmbox.types.Account.Info);
     */
    memberGet(input: Account_Id, options?: RpcOptions): UnaryCall<Account_Id, Account_Info>;
    /**
     * @generated from protobuf rpc: MemberSearch(mlmbox.client.network.AccountsSearchRequest) returns (mlmbox.types.Account.Info.List);
     */
    memberSearch(input: AccountsSearchRequest, options?: RpcOptions): UnaryCall<AccountsSearchRequest, Account_Info_List>;
    /**
     * @generated from protobuf rpc: TeamInfo(mlmbox.client.network.TeamRequest) returns (mlmbox.client.network.TeamResponse);
     */
    teamInfo(input: TeamRequest, options?: RpcOptions): UnaryCall<TeamRequest, TeamResponse>;
    /**
     * @generated from protobuf rpc: TeamSearch(mlmbox.client.network.AccountsSearchRequest) returns (mlmbox.types.Account.Info.List);
     */
    teamSearch(input: AccountsSearchRequest, options?: RpcOptions): UnaryCall<AccountsSearchRequest, Account_Info_List>;
    /**
     * @generated from protobuf rpc: TeamPartnerList(mlmbox.client.network.TeamPartnerListRequest) returns (mlmbox.types.Account.Info.List);
     */
    teamPartnerList(input: TeamPartnerListRequest, options?: RpcOptions): UnaryCall<TeamPartnerListRequest, Account_Info_List>;
}
/**
 * @generated from protobuf service mlmbox.client.network.Network
 */
export class NetworkClient implements INetworkClient, ServiceInfo {
    typeName = Network.typeName;
    methods = Network.methods;
    options = Network.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: MemberGet(mlmbox.types.Account.Id) returns (mlmbox.types.Account.Info);
     */
    memberGet(input: Account_Id, options?: RpcOptions): UnaryCall<Account_Id, Account_Info> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Account_Id, Account_Info>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: MemberSearch(mlmbox.client.network.AccountsSearchRequest) returns (mlmbox.types.Account.Info.List);
     */
    memberSearch(input: AccountsSearchRequest, options?: RpcOptions): UnaryCall<AccountsSearchRequest, Account_Info_List> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccountsSearchRequest, Account_Info_List>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: TeamInfo(mlmbox.client.network.TeamRequest) returns (mlmbox.client.network.TeamResponse);
     */
    teamInfo(input: TeamRequest, options?: RpcOptions): UnaryCall<TeamRequest, TeamResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<TeamRequest, TeamResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: TeamSearch(mlmbox.client.network.AccountsSearchRequest) returns (mlmbox.types.Account.Info.List);
     */
    teamSearch(input: AccountsSearchRequest, options?: RpcOptions): UnaryCall<AccountsSearchRequest, Account_Info_List> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccountsSearchRequest, Account_Info_List>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: TeamPartnerList(mlmbox.client.network.TeamPartnerListRequest) returns (mlmbox.types.Account.Info.List);
     */
    teamPartnerList(input: TeamPartnerListRequest, options?: RpcOptions): UnaryCall<TeamPartnerListRequest, Account_Info_List> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<TeamPartnerListRequest, Account_Info_List>("unary", this._transport, method, opt, input);
    }
}
